import React from 'react';
import { useFileExplorer } from '../../hooks/useFileExplorer';
import { FileExplorerTreeNode } from './FileExplorerTreeNode';
import { FileExplorerTreeSkeleton } from './FileExplorerTreeSkeleton';

export function FileExplorerFileTree() {
  // Fetch root data
  const { folders, isFileExplorerLoading } = useFileExplorer({ isRoot: true });

  return (
    <ul className="file-explorer-list">
      {
        isFileExplorerLoading
          ? <FileExplorerTreeSkeleton length={10} />
          : folders?.map((folder) => (
            <FileExplorerTreeNode data={folder} key={folder.id} />
          ))
      }
    </ul>
  );
}
